export default __webpack_public_path__ + "static/media/Home-Care-Elder-Care-Bg.6d61ba7a.svg";